import translations from './translations';

export function detectOsLocale() {
  if (typeof navigator === 'undefined') return 'en';
  return navigator.language || navigator.languages?.[0] || 'en';
}

export function resolveLanguage(stored, osLocale = detectOsLocale()) {
  if (stored && translations[stored]) return stored;
  const code = String(osLocale || 'en').toLowerCase().split('-')[0];
  return translations[code] ? code : 'en';
}
